import React, { Component } from "react";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";

import { Link } from "react-router-dom";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import $ from "jquery";
import Media from "react-media";

// The Header creates links that can be used to navigate
// between routes.
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      professionalsMenuItems: "",
      professionalsArray: ""
    };
  }
  componentDidMount() {
    this.loadProfessionals();
  }

  onChangeProfessional = key => {
    this.props.onChangeProfessional(
      this.state.professionalsArray[key].professionalId,
      this.state.professionalsArray[key].name +
        " " +
        this.state.professionalsArray[key].lastName
    );
  };

  loadProfessionals = async () => {
    const response = await fetch("http://190.105.227.203/turnos/profesionales");
    const res = await response.json();
    console.log(res);
    this.props.onChangeProfessional(
      res[0].professionalId,
      res[0].name + " " + res[0].lastName
    );
    const professionals = [];

    for (var i = 0; i < res.length; i++) {
      professionals.push(
        <MenuItem onSelect={this.onChangeProfessional} eventKey={i}>
          {res[i].name} {res[i].lastName}
        </MenuItem>
      );
    }
    console.log(professionals);
    this.setState({
      professionalsMenuItems: professionals,
      professionalsArray: res
    });
  };

  render() {
    console.log(window.location.href);
    let l = window.location.href;
    let current = l.substr(l.lastIndexOf("/") + 1);
    console.log(current);

    return (
      <React.Fragment>
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#home">Sistema Turnos</a>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav>
            <NavDropdown title="Profesionales" id="basic-nav-dropdown">
              {this.state.professionalsMenuItems}
            </NavDropdown>
          </Nav>
        </Navbar>
      </React.Fragment>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.jsx